import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';

import axios_api from '../../Api';

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../../Context';


export default function UserDataConfirmationModal ({modalId, handleClick, selectedYear}) {

  const [userProfile, setUserProfile] = useState(Object());
  const [userLabType, setUserLabType] = useState('');
  const [allFieldsFilled, setAllFieldsField] = useState(true);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {

    let userProfileNext = axios_api.get(api_url + '/profile/', {
      headers: {"Authorization": token}
    });
 
    userProfileNext.then(
      (result) => {
        setUserProfile(result.data);

        for (const [key, value] of Object.entries(result.data)) {
          
          //  необязательные поля в профиле
          if (['certificate', 'secretary_phone', 'secretary_email', 'accounting_phone', 'accounting_email'].includes(key)){
            // console.log(key)
            continue;
          }
          if (value === "" || value === null) {
            setAllFieldsField(false);
          }
        }  
        
        let labTypeGuid = result.data.lab_type
        let labTypesNext = axios_api.get(api_url + '/lab_types/', {
          headers: {"Authorization": token}
        });

        labTypesNext.then(
          (result) => {
            let index = result.data.findIndex(item => item.guid === labTypeGuid);
            let labType = '';
            index === -1 ? labType = '' : labType = result.data[index].type;
            setUserLabType(labType);
          },
          (error) => {
            console.log(error)
          }
        );
      },
      (error) => {
        console.log(error)
      }
    );
  }, []);


  function FieldWarning() {
    return(<span className='text-danger fw-bold'>необходимо заполнить поле</span>)
  }


  return (
    <div className="modal fade modal-lg" id={modalId} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-light">
            <h2 className="modal-title fs-5" id={modalId + "Label"}>Для оформления заказа и договора пожалуйста подтвердите подлинность учетных данных:</h2>
            <button type="button" className="btn-close me-3" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          {allFieldsFilled === false ? 
            <div className="text-center align-middle modal-warning">
              <span>Для оформления заказа необходимо дополнить учетные данные</span>
            </div> : 
            <></>
          }
          <div className="modal-body">
            <p><b>Название организации:</b> {userProfile.organization ? userProfile.organization : <FieldWarning/>}</p>
            <p><b>Руководитель:</b> {userProfile.director ? userProfile.director : <FieldWarning/>}</p>
            <p><b>Действующий на основании:</b> {userProfile.law_basis ? userProfile.law_basis : <FieldWarning/>}</p>
            <p><b>Тип лабортатории:</b> {userLabType ? userLabType : <FieldWarning/>}</p>
            <p><b>Заведующий Лабораторией:</b> {userProfile.lab_chief ? userProfile.lab_chief : <FieldWarning/>}</p>
            <p><b>Контактный телефон:</b> {userProfile.organization_phone ? userProfile.organization_phone : <FieldWarning/>}</p>
            <p><b>Мобильный телефон заведующего:</b> {userProfile.organization_mobile_phone ? userProfile.organization_mobile_phone : <FieldWarning/>}</p>
            <p><b>Электронная почта заведующего:</b> {userProfile.organization_email ? userProfile.organization_email : <FieldWarning/>}</p>
            <p><b>Адрес доставки контрольных образцов:</b> {userProfile.delivery_address ? userProfile.delivery_address : <FieldWarning/>}</p>
            <p><b>Получатель:</b> {userProfile.recipient ? userProfile.recipient : <FieldWarning/>}</p>
            <p><b>Аттестат аккредитации:</b> {userProfile.certificate ? userProfile.certificate : ''}</p>
            <p><b>СекретатьТелефон:</b> {userProfile.secretary_phone ? userProfile.secretary_phone : ''}</p>
            <p><b>СекретарьПочта:</b> {userProfile.secretary_email ? userProfile.secretary_email : ''}</p>
            <p><b>БухгалтерТелефон:</b> {userProfile.accounting_phone ? userProfile.accounting_phone : ''}</p>
            <p><b>БухгалтерПочта:</b> {userProfile.accounting_email ? userProfile.accounting_email : ''}</p>
            <p><b>Кодовое слово:</b> {userProfile.code_word ? userProfile.code_word : <FieldWarning/>}</p>
            <p><b>Юридический адрес:</b> {userProfile.legal_address ? userProfile.legal_address : <FieldWarning/>}</p>
            <p><b>ИНН:</b> {userProfile.inn ? userProfile.inn : <FieldWarning/>}</p>
            <p><b>КПП:</b> {userProfile.kpp ? userProfile.kpp : <FieldWarning/>}</p> 
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary lk-bootstrap-button" data-bs-dismiss="modal">Отмена</button>
            <a className="btn btn-secondary lk-bootstrap-button" href="/profile">Отредактировать данные</a>
            {allFieldsFilled === true ? 
              <button type="button" className="btn lk-button" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleClick(selectedYear)}>Подтверждаю</button>
              : 
              <></>
            }
          </div>
        </div>
      </div>
    </div>
  )
}